var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';
const IconButton = (props) => {
    const { children, active, onClick, endIcon } = props, rest = __rest(props, ["children", "active", "onClick", "endIcon"]);
    return (React.createElement(Button, Object.assign({ variant: 'contained', endIcon: endIcon, onClick: onClick, disableElevation: true, sx: (theme) => (Object.assign({ position: 'relative', minWidth: 'auto', color: theme.palette.text.secondary, padding: '8px 9px', height: '100%', marginLeft: theme.spacing(1), bgcolor: 'background.default', span: {
                margin: theme.spacing(0),
            }, path: {
                fill: theme.palette.text.secondary,
            }, '&:hover, &.active': {
                bgcolor: 'background.default',
            } }, (active && {
            color: theme.palette.primary.main + '!important',
            bgcolor: alpha(theme.palette.primary.main, 0.12) + '!important',
            path: {
                fill: theme.palette.primary.main,
            },
        }))) }, rest), children));
};
export default IconButton;
